import React from 'react';
import styled, { css } from 'styled-components';

import { Page, ErrorModule as TagerError } from '@tager/web-components';

import Link from '@/components/Link';
import Layout from '@/components/Layout';
import { useTranslation } from '@/components/I18nProvider';

function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Page title={t('pageNotFound')}>
      <Layout>
        {/*<TagerError errorCode={404} errorName="Page not found" />*/}
        <ErrorBlock>
          <Title>404</Title>
          <Text>{t('pageNotFound')}</Text>
          <InfoTextBlock>
            {t('thisPageDoesNotExist')},{' '}
            <Link as={InfoText} to={'/'}>
              {t('returnToHome')}
            </Link>
          </InfoTextBlock>
        </ErrorBlock>
      </Layout>
    </Page>
  );
}

const ErrorBlock = styled.div`
  text-align: center;
  margin: auto auto;
  padding-bottom: 67px;
  vertical-align: middle;
`;
const Title = styled.h1`
  font-size: 108px;
  margin-top: 0;
  margin-bottom: 10px;
`;
const Text = styled.h2`
  font-size: 30px;
  padding-bottom: 15px;
`;
const InfoTextBlock = styled.h3``;
const InfoText = styled.a`
  color: #ff0000;
  border-bottom: red solid 1px;
`;

export default NotFoundPage;
